import React from 'react';
import moment from 'moment';

import StandardButton from 'app/components/button/StandardButton';
import { DATA_GRID_ACTIONS } from 'app/components/dataGrid/DataColumn';
import DataGrid from 'app/components/dataGrid/DataGrid';
import Filter from 'app/components/filter/Filter';
import FilterOption from 'app/components/filter/FilterOption';
import SearchBar from 'app/components/searchBar/SearchBar';
import CalendarFilter from 'app/components/calendar/CalendarFilter';
import PrivateLayout from 'app/layout/PrivateLayout';
import { IEmailScheduleManager, IScheduleDate } from 'app/models/email';
import { IGradeBand } from 'app/models/program';
import {
  ICategoryTag,
  IDesignation,
  IPopulation,
  IActiveStatus,
} from 'app/models/common';
import useEmailScheduleManagerListing from 'app/hooks/EmailScheduleManagerListing';
import Switch from 'app/components/switch/Switch';
import {
  formatGradeBand,
  formatContentDesignation,
  formatCategoryTags,
  formatCategoryTagsFromId,
  formatApprovalStatus,
} from 'app/utils/data';
import { ACTIVE_OPTIONS } from 'app/utils/common';
import ScreenNotification from 'app/components/screenNotification/ScreenNotification';
import { ReactComponent as RepeatIcon } from 'app/assets/icons/repeat.svg';
import './email.scss';

const GRID_ID = 'email-schedule-manager-listing';

const EmailScheduleManager: React.FC = () => {
  const _emailScheduleListing = useEmailScheduleManagerListing();

  console.log({ data: _emailScheduleListing });
  return (
    <PrivateLayout contentClassName='email-schedule-manager-listing'>
      <StandardButton
        label='+ Schedule New Email'
        variant='secondary'
        className='new-schedule-email-button'
        onClick={_emailScheduleListing.onScheduleNewEmailClick}
        standardBtnId='email-schedule-manager-listing-new-btn'
      />
      <h3 className='title'>Email Schedule Manager</h3>
      <ScreenNotification
        label='Errors'
        variant='danger'
        styles={{ container: { marginTop: '2rem' } }}
      />
      <SearchBar
        placeHolder='Search by description, keyword or email ID'
        searchBarId='email-schedule-manager-search'
        onChangeText={_emailScheduleListing.onSearchKeyChange}
        onSearch={_emailScheduleListing.onSearch}
      />
      <Filter
        id='email-schedule-manager-listing-filter'
        onFilterChange={_emailScheduleListing.onFilterChange}
        selectedFilters={_emailScheduleListing.filters}
      >
        <FilterOption<IGradeBand>
          labelAttribute='gradeBand'
          valueAttribute='id'
          name='gradeBandIds'
          options={_emailScheduleListing.gradeBands}
          placeholder='Grade Band'
        />
        <FilterOption<IDesignation>
          // labelAttribute="designation"
          labelAttribute='designationType'
          valueAttribute='id'
          name='designationIds'
          options={_emailScheduleListing.contentDesignations}
          placeholder='Designation'
        />
        <FilterOption<ICategoryTag>
          // labelAttribute="category"
          labelAttribute='categoryTag'
          valueAttribute='id'
          name='categoryIds'
          options={_emailScheduleListing.categoryTags}
          placeholder='Category Tags'
        />
        {/* <FilterOption<IScheduleDate>
          labelAttribute='scheduleDate'
          valueAttribute='id'
          name='scheduleDate'
          options={[]}
          placeholder='Schedule Date'
          component={CalendarFilter}
          getValues={_emailScheduleListing.getCalendarFilterValues}
          getSelectedOptions={
            _emailScheduleListing.getSelectedOptionsForCalendarFilter
          }
        /> */}
        <FilterOption<IPopulation>
          labelAttribute='population'
          valueAttribute='id'
          name='population'
          options={_emailScheduleListing.populations}
          placeholder='Population'
        />
        <FilterOption<IActiveStatus>
          labelAttribute='label'
          valueAttribute='isActive'
          name='status'
          options={ACTIVE_OPTIONS}
          placeholder='Status'
        />
      </Filter>
      <DataGrid<IEmailScheduleManager>
        data={_emailScheduleListing.data}
        gridId={GRID_ID}
        rowIdAttribute='id'
        currentPage={_emailScheduleListing.currentPage}
        onPageChange={_emailScheduleListing.onPageChange}
        totalItems={_emailScheduleListing.totalItems}
        onAction={_emailScheduleListing.onGridAction}
      >
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='notification_template_id'
          header='Email ID'
        />
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='template'
          header='Email Description'
          transform={(data) => data.template.name}
        />
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='template'
          header='Grade Band'
          transform={(data) => formatGradeBand(data.grade_bands)}
        />
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='template'
          header='Designation Type'
          transform={(data) =>
            formatContentDesignation(
              _emailScheduleListing.contentDesignations,
              data.template?.content_designation_id
            )
          }
        />
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='categoryTags'
          header='Category Tags'
          transform={(data) =>
            formatCategoryTagsFromId(
              _emailScheduleListing.categoryTags,
              data.template?.category_ids
            )
          }
        />
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='template'
          header='Approval Status'
          transform={(data) =>
            formatApprovalStatus(
              _emailScheduleListing.approvalStatuses,
              data.template?.content_approval_status_id
            )
          }
        />
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='next_delivery_at'
          header='Send Date'
          transform={(data) => {
            return (
              <div className='email-schedule-send-date'>
                {moment(data.next_delivery_at).format('MM/DD/YYYY')}
                {data.delivery_frequency !== 'Once' && (
                  <RepeatIcon className='email-schedule-repeat-icon' />
                )}
              </div>
            );
          }}
        />
        {/* <DataGrid.Column<IEmailScheduleManager>
          attributeName='population'
          header='Population'
        /> */}
        <DataGrid.Column<IEmailScheduleManager>
          attributeName='is_enabled'
          header='Schedule Enabled'
          transform={(schedule) => {
            return (
              <Switch
                checked={schedule.is_enabled}
                onChange={_emailScheduleListing.onToggleActivateStatus(
                  schedule
                )}
                switchId='email-schedule-manager-activate-status-btn'
              />
            );
          }}
        />
        <DataGrid.Column<IEmailScheduleManager>
          action={DATA_GRID_ACTIONS.PREVIEW}
          attributeName='GRID.ACTIONS'
        />
        <DataGrid.Column<IEmailScheduleManager>
          action={DATA_GRID_ACTIONS.EDIT_SCHEDULE}
          attributeName='GRID.ACTIONS'
        />
      </DataGrid>
    </PrivateLayout>
  );
};

export default EmailScheduleManager;
